import { useCalendarService } from '@mews-commander/ui';
import { StructuredDate } from '@optimus-web/core';

export const useBirthdateDateLimits = () => {
    const calendar = useCalendarService();

    const maxDate = calendar.getCurrentDate();
    const minDate: StructuredDate = {
        year: 1900,
        month: 1,
        date: 1,
    };

    return {
        maxDate,
        minDate,
    };
};
